import { openBlock as i, createElementBlock as d, createElementVNode as f, defineComponent as ie, computed as s, normalizeClass as B, normalizeStyle as k, unref as r, withKeys as Le, createCommentVNode as x, withDirectives as j, createVNode as ue, vShow as H, toDisplayString as de, ref as g, onMounted as $e, watch as Ee, renderSlot as Re, Transition as Ve, withCtx as Ae, Fragment as U, renderList as N, createBlock as ae, withModifiers as De } from "vue";
const D = {
  colors: [
    "#1FBC9C",
    "#1CA085",
    "#2ECC70",
    "#27AF60",
    "#3398DB",
    "#2980B9",
    "#A463BF",
    "#8E43AD",
    "#3D556E",
    "#222F3D",
    "#F2C511",
    "#F39C19",
    "#E84B3C",
    "#C0382B",
    "#DDE6E8",
    "#BDC3C8"
  ],
  rowLength: 4
}, oe = {
  colors: [
    "#CC0001",
    "#E36101",
    "#FFCC00",
    "#009900",
    "#0066CB",
    "#000000",
    "#FFFFFF"
  ],
  showBorder: !0
}, re = {
  colors: [
    [
      "#000000",
      "#434343",
      "#666666",
      "#999999",
      "#b7b7b7",
      "#cccccc",
      "#d9d9d9",
      "#efefef",
      "#f3f3f3",
      "#ffffff"
    ],
    [
      "#980000",
      "#ff0000",
      "#ff9900",
      "#ffff00",
      "#00ff00",
      "#00ffff",
      "#4a86e8",
      "#0000ff",
      "#9900ff",
      "#ff00ff"
    ],
    [
      "#e6b8af",
      "#f4cccc",
      "#fce5cd",
      "#fff2cc",
      "#d9ead3",
      "#d0e0e3",
      "#c9daf8",
      "#cfe2f3",
      "#d9d2e9",
      "#ead1dc"
    ],
    [
      "#dd7e6b",
      "#ea9999",
      "#f9cb9c",
      "#ffe599",
      "#b6d7a8",
      "#a2c4c9",
      "#a4c2f4",
      "#9fc5e8",
      "#b4a7d6",
      "#d5a6bd"
    ],
    [
      "#cc4125",
      "#e06666",
      "#f6b26b",
      "#ffd966",
      "#93c47d",
      "#76a5af",
      "#6d9eeb",
      "#6fa8dc",
      "#8e7cc3",
      "#c27ba0"
    ],
    [
      "#a61c00",
      "#cc0000",
      "#e69138",
      "#f1c232",
      "#6aa84f",
      "#45818e",
      "#3c78d8",
      "#3d85c6",
      "#674ea7",
      "#a64d79"
    ],
    [
      "#85200c",
      "#990000",
      "#b45f06",
      "#bf9000",
      "#38761d",
      "#134f5c",
      "#1155cc",
      "#0b5394",
      "#351c75",
      "#741b47"
    ],
    [
      "#5b0f00",
      "#660000",
      "#783f04",
      "#7f6000",
      "#274e13",
      "#0c343d",
      "#1c4587",
      "#073763",
      "#20124d",
      "#4c1130"
    ]
  ],
  borderRadius: "0",
  rowLength: 10,
  swatchSize: 24,
  spacingSize: 0
};
const Oe = (l, o) => {
  const t = l.__vccOpts || l;
  for (const [b, y] of o)
    t[b] = y;
  return t;
}, Te = {}, We = { class: "vue-swatches__check__wrapper vue-swatches--has-children-centered" }, Me = /* @__PURE__ */ f("div", { class: "vue-swatches__check__circle vue-swatches--has-children-centered" }, [
  /* @__PURE__ */ f("svg", {
    version: "1.1",
    role: "presentation",
    width: "12",
    height: "12",
    viewBox: "0 0 1792 1792",
    class: "check"
  }, [
    /* @__PURE__ */ f("path", {
      class: "vue-swatches__check__path",
      d: "M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
    })
  ])
], -1), Ie = [
  Me
];
function Pe(l, o) {
  return i(), d("div", We, Ie);
}
const qe = /* @__PURE__ */ Oe(Te, [["render", Pe]]), Ue = ["aria-label"], Ne = {
  key: 0,
  class: "vue-swatches__diagonal__wrapper vue-swatches--has-children-centered"
}, je = /* @__PURE__ */ f("div", { class: "vue-swatches__diagonal" }, null, -1), He = [
  je
], ce = /* @__PURE__ */ ie({
  __name: "VSwatch",
  props: {
    borderRadius: null,
    isLast: { type: Boolean, default: !1 },
    rowLengthSetted: { type: Boolean, default: !1 },
    disabled: { type: Boolean },
    inline: { type: Boolean },
    selected: { type: Boolean, default: !1 },
    showCheckbox: { type: Boolean },
    showBorder: { type: Boolean },
    showLabels: { type: Boolean },
    spacingSize: { default: 42 },
    swatchColor: { default: "" },
    swatchLabel: null,
    swatchAlt: null,
    swatchSize: null,
    swatchStyle: null
  },
  setup(l) {
    const o = l, t = s(() => ({
      bottom: `-${8 + Math.floor(o.spacingSize / 5) * 3}px`
    })), b = s(() => {
      const h = {
        width: `${o.swatchSize}px`,
        height: `${o.swatchSize}px`,
        borderRadius: o.borderRadius,
        backgroundColor: o.swatchColor !== "" ? o.swatchColor : "#FFFFFF",
        cursor: y.value
      };
      return (!o.inline || !o.isLast) && (h.marginRight = `${o.spacingSize}px`), o.inline && !o.rowLengthSetted ? h : {
        ...h,
        marginBottom: `${o.spacingSize}px`
      };
    }), y = s(() => o.disabled ? "not-allowed" : "pointer"), z = s(() => [t.value]), O = s(() => [b.value, o.swatchStyle]);
    return (h, w) => (i(), d("div", {
      class: B(["vue-swatches__swatch", {
        "vue-swatches__swatch--border": l.showBorder,
        "vue-swatches__swatch--selected": l.selected,
        "vue-swatches__swatch--is-disabled": l.disabled
      }]),
      style: k(r(O)),
      "aria-label": l.swatchAlt,
      role: "button",
      tabindex: "0",
      onKeyup: w[0] || (w[0] = Le((F) => h.$emit("click", l.swatchColor), ["enter"])),
      onBlur: w[1] || (w[1] = (F) => h.$emit("blur", F.relatedTarget))
    }, [
      l.swatchColor === "" ? (i(), d("div", Ne, He)) : x("", !0),
      j(ue(qe, null, null, 512), [
        [H, l.showCheckbox && l.selected]
      ]),
      l.showLabels ? (i(), d("div", {
        key: 1,
        class: "vue-swatches__swatch__label",
        style: k(r(z))
      }, de(l.swatchLabel), 5)) : x("", !0)
    ], 46, Ue));
  }
});
const Ge = { class: "vue-swatches__diagonal__wrapper vue-swatches--has-children-centered" }, Xe = /* @__PURE__ */ f("div", { class: "vue-swatches__diagonal" }, null, -1), Ye = [
  Xe
], Ke = { class: "vue-swatches__fallback__input--wrapper" }, Ze = ["value", "type"], Je = ["onClick"], Qe = /* @__PURE__ */ ie({
  __name: "VSwatches",
  props: {
    backgroundColor: { default: "#ffffff" },
    closeOnSelect: { type: Boolean, default: !0 },
    swatches: { default: () => "basic" },
    disabled: { type: Boolean, default: !1 },
    fallbackInputClass: { default: null },
    fallbackInputType: { default: () => "text" },
    fallbackOkClass: { default: null },
    fallbackOkText: { default: "Ok" },
    inline: { type: Boolean, default: !1 },
    shapes: { default: "squares" },
    popoverX: { default: "right" },
    popoverY: { default: "bottom" },
    rowLength: { default: null },
    showBorder: { type: [Boolean, null], default: null },
    showFallback: { type: Boolean, default: !1 },
    showCheckbox: { type: Boolean, default: !0 },
    showLabels: { type: Boolean, default: !1 },
    spacingSize: { default: null },
    swatchSize: { default: null },
    swatchStyle: null,
    triggerStyle: null,
    wrapperStyle: null,
    modelValue: { default: "" }
  },
  emits: ["close", "open", "update:modelValue"],
  setup(l, { emit: o }) {
    const t = l, b = g(null), y = g(null), z = g(null), O = "10px", h = 4, w = 5, F = 42, fe = !1, S = (e, n, a) => typeof e != "string" ? null : e === "text-basic" ? oe[n] === void 0 ? null : oe[n] : e === "text-advanced" ? re[n] === void 0 ? null : re[n] : e === "basic" || a ? D[n] === void 0 ? null : D[n] : null, G = g({}), X = g(!1), m = g(t.modelValue), L = g(!1);
    $e(() => {
      X.value = !0;
    });
    const Y = s(() => !!(v.value && v.value.length && v.value[0] instanceof Array)), $ = s(() => t.inline ? !1 : L.value), he = s(() => T("", t.modelValue)), K = s(() => S(t.swatches, "borderRadius")), E = s(() => S(t.swatches, "rowLength")), Z = s(() => S(t.swatches, "showBorder")), J = s(() => S(t.swatches, "swatchSize")), Q = s(() => S(t.swatches, "spacingSize")), v = s(() => t.swatches instanceof Array ? t.swatches : typeof t.swatches == "string" ? S(t.swatches, "colors", !0) : []), ee = s(() => K.value !== null ? K.value : be.value), we = s(() => t.rowLength !== null ? Number(t.rowLength) : E.value !== null ? E.value : v.value.length < h && !Y.value ? v.value.length : h), _ = s(() => t.swatchSize !== null ? Number(t.swatchSize) : J.value !== null ? J.value : F), p = s(() => t.spacingSize !== null ? t.spacingSize : Q.value !== null ? Q.value : Math.round(_.value * 0.25)), te = s(() => t.showBorder !== null ? t.showBorder : Z.value !== null ? Z.value : fe), ve = s(() => !t.inline), be = s(() => t.shapes === "squares" ? `${Math.round(_.value * 0.25)}px` : t.shapes === "circles" ? "50%" : ""), le = s(() => we.value * (_.value + p.value)), pe = s(() => ({
      width: "42px",
      height: "42px",
      backgroundColor: t.modelValue ? t.modelValue : "#ffffff",
      borderRadius: t.shapes === "circles" ? "50%" : O
    })), ge = s(() => [pe.value, t.triggerStyle]), ye = s(() => {
      const e = [
        {
          backgroundColor: t.backgroundColor
        },
        G.value
      ];
      return t.inline ? e : [
        ...e,
        {
          padding: "5px",
          marginBottom: "5px"
        }
      ];
    }), Se = s(() => t.inline ? {} : {
      paddingTop: `${p.value}px`,
      paddingLeft: `${p.value}px`,
      width: `${le.value}px`
    }), ke = s(() => [Se.value, t.wrapperStyle]), me = s(() => {
      const e = {
        marginLeft: `${p.value}px`,
        paddingBottom: `${p.value}px`
      };
      return t.inline ? e : {
        ...e,
        width: `${le.value - p.value}px`
      };
    }), _e = s(() => [me.value]);
    Ee(() => t.modelValue, (e) => {
      m.value = e;
    });
    function T(e, n) {
      return !e && e !== "" || !n && n !== "" ? !1 : e.toUpperCase() === n.toUpperCase();
    }
    function W() {
      var e;
      L.value = !1, (e = b.value) == null || e.blur(), o("close", m.value);
    }
    function Ce() {
      const e = {}, n = y.value, a = z.value;
      if (!X.value || t.inline || !n || !window || !document)
        return e;
      const c = n.getBoundingClientRect(), u = 5, R = (document.documentElement.clientWidth || window.innerWidth) - 5, V = 5, Fe = (document.documentElement.clientHeight || window.innerHeight) - 5;
      a.style.visibility = "hidden", a.style.display = "block";
      const A = a.getBoundingClientRect();
      return a.style.display = "none", a.style.visibility = "visible", t.popoverY === "top" ? c.top - A.height < V ? (e.top = `${c.height + w}px`, e.bottom = "auto") : (e.bottom = `${c.height + w}px`, e.top = "auto") : t.popoverY === "bottom" && (c.bottom + A.height > Fe ? (e.bottom = `${c.height + w}px`, e.top = "auto") : (e.top = `${c.height + w}px`, e.bottom = "auto")), t.popoverX === "left" ? c.right - A.width < u ? (e.left = 0, e.right = "auto") : (e.right = 0, e.left = "auto") : t.popoverX === "right" && (c.left + A.width > R ? (e.right = 0, e.left = "auto") : (e.left = 0, e.right = "auto")), e;
    }
    function ne(e) {
      if (typeof e == "string")
        return te.value;
      if (typeof e == "object")
        return e.showBorder !== void 0 ? e.showBorder : te.value;
    }
    function C(e) {
      if (typeof e == "string")
        return e;
      if (typeof e == "object")
        return e.color;
    }
    function M(e) {
      if (typeof e == "string")
        return t.disabled;
      if (typeof e == "object")
        return e.disabled !== void 0 ? e.disabled : t.disabled;
    }
    function I(e) {
      if (typeof e == "string")
        return e;
      if (typeof e == "object")
        return e.label || e.color;
    }
    function se(e) {
      if (typeof e == "string")
        return e;
      if (typeof e == "object")
        return e.alt || I(e);
    }
    function P(e) {
      var n;
      !$.value || e !== null && ((n = b.value) == null ? void 0 : n.contains(e)) || (L.value = !1, o("close", m.value));
    }
    function Be() {
      W();
    }
    function xe() {
      var e;
      $.value || t.inline || t.disabled || (G.value = Ce(), L.value = !0, (e = b.value) == null || e.focus(), o("open"));
    }
    function ze() {
      $.value ? W() : xe();
    }
    function q(e, { fromFallbackInput: n } = {}) {
      if (M(e))
        return;
      const a = C(e);
      m.value = a, o("update:modelValue", a), t.closeOnSelect && !t.inline && !n && W();
    }
    return (e, n) => (i(), d("div", {
      class: "vue-swatches",
      tabindex: "-1",
      ref_key: "main",
      ref: b,
      onBlur: n[3] || (n[3] = (a) => P(a.relatedTarget))
    }, [
      l.inline ? x("", !0) : (i(), d("div", {
        key: 0,
        ref_key: "triggerWrapper",
        ref: y,
        class: "vue-swatches__trigger__wrapper",
        onClick: ze
      }, [
        Re(e.$slots, "trigger", {}, () => [
          f("div", {
            class: B(["vue-swatches__trigger", {
              "vue-swatches--is-empty": !l.modelValue,
              "vue-swatches--is-disabled": l.disabled
            }]),
            style: k(r(ge))
          }, [
            j(f("div", Ge, Ye, 512), [
              [H, r(he)]
            ])
          ], 6)
        ])
      ], 512)),
      ue(Ve, { name: "vue-swatches-show-hide" }, {
        default: Ae(() => [
          j(f("div", {
            ref_key: "containerWrapper",
            ref: z,
            class: B(["vue-swatches__container", { "vue-swatches--inline": l.inline }]),
            style: k(r(ye))
          }, [
            f("div", {
              class: "vue-swatches__wrapper",
              style: k(r(ke))
            }, [
              r(Y) ? (i(!0), d(U, { key: 0 }, N(r(v), (a, c) => (i(), d("div", {
                key: c,
                class: "vue-swatches__row"
              }, [
                (i(!0), d(U, null, N(a, (u, R) => (i(), ae(ce, {
                  key: R,
                  "is-last": c === r(v).length - 1 && R === a.length,
                  "row-length-setted": l.rowLength !== null || r(E) !== null,
                  "border-radius": r(ee),
                  disabled: M(u),
                  inline: l.inline,
                  selected: T(C(u), l.modelValue),
                  "swatch-size": r(_),
                  "spacing-size": r(p),
                  "show-border": ne(u),
                  "show-checkbox": l.showCheckbox,
                  "show-labels": l.showLabels,
                  "swatch-color": C(u),
                  "swatch-label": I(u),
                  "swatch-alt": se(u),
                  "swatch-style": l.swatchStyle,
                  onBlur: n[0] || (n[0] = (V) => P(V)),
                  onClick: (V) => q(u)
                }, null, 8, ["is-last", "row-length-setted", "border-radius", "disabled", "inline", "selected", "swatch-size", "spacing-size", "show-border", "show-checkbox", "show-labels", "swatch-color", "swatch-label", "swatch-alt", "swatch-style", "onClick"]))), 128))
              ]))), 128)) : (i(!0), d(U, { key: 1 }, N(r(v), (a, c) => (i(), ae(ce, {
                key: c,
                "is-last": c === r(v).length - 1,
                "row-length-setted": l.rowLength !== null || r(E) !== null,
                "border-radius": r(ee),
                disabled: M(a),
                inline: l.inline,
                selected: T(C(a), l.modelValue),
                "swatch-size": r(_),
                "spacing-size": r(p),
                "show-border": ne(a),
                "show-checkbox": l.showCheckbox,
                "show-labels": l.showLabels,
                "swatch-color": C(a),
                "swatch-label": I(a),
                "swatch-alt": se(a),
                "swatch-style": l.swatchStyle,
                onBlur: n[1] || (n[1] = (u) => P(u)),
                onClick: (u) => q(a)
              }, null, 8, ["is-last", "row-length-setted", "border-radius", "disabled", "inline", "selected", "swatch-size", "spacing-size", "show-border", "show-checkbox", "show-labels", "swatch-color", "swatch-label", "swatch-alt", "swatch-style", "onClick"]))), 128))
            ], 4),
            l.showFallback ? (i(), d("div", {
              key: 0,
              class: "vue-swatches__fallback__wrapper",
              style: k(r(_e))
            }, [
              f("span", Ke, [
                f("input", {
                  ref: "fallbackInput",
                  class: B(["vue-swatches__fallback__input", l.fallbackInputClass]),
                  value: m.value,
                  type: l.fallbackInputType,
                  onInput: n[2] || (n[2] = (a) => q(a.target.value, { fromFallbackInput: !0 }))
                }, null, 42, Ze)
              ]),
              r(ve) ? (i(), d("button", {
                key: 0,
                class: B(["vue-swatches__fallback__button", l.fallbackOkClass]),
                onClick: De(Be, ["prevent"])
              }, de(l.fallbackOkText), 11, Je)) : x("", !0)
            ], 4)) : x("", !0)
          ], 6), [
            [H, l.inline || r($)]
          ])
        ]),
        _: 1
      })
    ], 544));
  }
});
const tt = [
  "colors",
  "borderRadius",
  "rowLength",
  "swatchSize",
  "spacingSize",
  "showBorder"
];
function lt(l) {
  l.component("VSwatches", Qe);
}
export {
  Qe as VSwatches,
  D as basic,
  lt as default,
  tt as supportedProperties,
  re as textAdvanced,
  oe as textBasic
};
